import * as React from 'react';
import classNames from 'classnames';
import './Box.scss';

export interface IBoxProps {
  children?: any;
  className?: string;
}

const Box = ({ children, className }: IBoxProps) => (
  <div 
    className={classNames(
      'box',
      className
    )}
  >
    {children}
  </div>
);

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box/index.tsx